
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide, swiperItem } from "vue-awesome-swiper";
import Catalog from "@/components/LessionCatalog";
import PackCatalog from "@/components/packageCatalog";
import Comment from "@/components/Comment";

import {
getCoursesDetail,
getCourseChapter,
getCollect,
getHomeList,
getBuyfree,
DelCollect
} from "@/api/home";
import { getLiveBackInfo, getpintuanList } from "@/api/watch";
import XDialog from 'vux/src/components/x-dialog/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import { mapGetters, mapActions } from "vuex";
import { staticHost } from "@/common/js/config";
import { addIntegral } from "@/common/js/util";

export default {
name: "LessionDetail",
components: {
Catalog,
Comment,
swiper,
swiperSlide,
swiperItem,
XDialog,
Toast,
LoadMore,

PackCatalog
},
data() {
return {
checkBeforeBuy: true,
name: "",
currentTab: "介绍",
showVideo: false,
earnShow: 2,
earnMoney: 0,
shareuserid: "",
ordertype: "",
showpintuan: false,




ptNumber: 0,
swiperList: [],
pintuanArr: [],
userhead: require("@/common/image/people.png"),
username: "",
timeArr: {
h: "00",
m: "00",
s: "00"
},
swiperOption: {
pagination: {
el: ".swiper-pagination"
},
direction: "vertical",
autoplay: {
delay: 4000,
stopOnLastSlide: false,
/* 触摸滑动后是否继续轮播 */
disableOnInteraction: false
},
loopedSlides: 2,
slidesPerview: "auto",
loop: true
},
tabList: [
{
id: 1,
name: "介绍",
choosed: true
},
{
id: 2,
name: "章节"
},
{
id: 3,
name: "评论"
}
],
imgList: Object.freeze({
share: require("@/common/image/course/share.png"),
look: require("@/common/image/course/look.png"),
xiabiao: require("@/common/image/course/xiabiao.png"),
collect: require("@/common/image/course/collection.png"),
consult: require("@/common/image/course/consult.png"),
collectActive: require("@/common/image/course/collectionActive.png")
}),








lessionList: [],
lessionType: "buy",
collect: false, // 是否收藏
currentPrice: "",
BeforePrice: "",
showVideoPlay: false,
detailTitle: "",
detailName: "",
detailContext: "",
courseid: 0, // 课程id
freeUrl: "", // 第一个免费的视频
showToast: false,
sellType: "",
loading: false,
videoImg: "",
scriptContetn: "",
isBuy: 0,
share: null,
kefu: "",
player: null,
livePlayStau: "",
childinfoData: null,
spellgroupprice: "",
spellStatus: 2,
spellgroupstatus: 0, // 拼团进行中

index: 1,
isavaliable: 0,
sharewechat: false,
fromPage: "",
canBuyFlag: false,
userMemberCourse: null,

getCourseChapterData: null
};
},
methods: {
...mapActions(["saveUserAction", "saveCollegeAction"]),
clicksharewx() {
let _this = this;
let imgval =
this.videoImg.indexOf("http") >= 0
? this.videoImg
: staticHost + this.videoImg;
try {
if (/android/i.test(window.navigator.userAgent)) {
AppUtil.redirect(
"share-wechat-mini-program",
_this.detailName,
imgval,
_this.courseid
);
} else if (/iphone/i.test(window.navigator.userAgent)) {
window.webkit.messageHandlers.redirect.postMessage({
type: "share-wechat-mini-program",
title: _this.detailName,
img: imgval,
courseid: _this.courseid
});
}
} catch (e) {
console.log(e);
}
},
scrollEvent(e) {
if (e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight) {
this.getDataList();
}
},
gopintuan(orderid) {
this.$router.push({
path: "/pin/pindetail",
query: {
orderId: orderid
}
});
},
getDataList() {
this.loading = true;
this.index = this.index + 1;
let data = {
courseId: this.courseid,
currentPage: this.index,
pageSize: 6
};
this.loading = true;
getpintuanList(data).then(res => {
this.loading = false;
if (!res.entity.orderList) return;
this.swiperList = this.swiperList.concat(res.entity.orderList);
});
},
pintuanList() {
let dt = {
courseId: this.courseid,
currentPage: 1,
pageSize: 6
};
getpintuanList(dt).then(res => {

if (!res.entity.orderList) return;
this.ptNumber = res.entity.page.totalResultSize;
this.swiperList = res.entity.orderList;
this.beginTimer();
});
},
goSpell() {
this.$router.push({
path: "/payorder",
query: {
courseid: this.courseid,
from: "spell"
}
});
},

goAsk() {
window.location.href = this.kefu;
},
play() {
if (!this.freeUrl) {
this.showToast = true;
} else {
this.showVideo = true;
}
},
playerVideo(val) {
this.freeUrl = val;
this.play();
},






changeTab(val, index) {
this.currentTab = val.name;
this.tabList = this.tabList.map(item => {
if (item.choosed) delete item.choosed;
return item;
});
this.$set(val, "choosed", true);
},

toCollect() {
if (!this.user || (this.user && !this.user.id)) {
this.gotoAppLogin();
return;
}
let dt = {
userId: this.user.id,
courseId: this.courseid,
sellType: "COURSE"
};
getCollect(dt).then(res => {
if (res.success) {
this.$vux.toast.text("收藏成功");
this.collect = true;
}
});
let data = {
user_id: this.user.id,
college_id: this.college.id,
scene_type: "fav"
};
addIntegral(data);
},

cancelCollect() {
if (!this.user || (this.user && !this.user.id)) {
this.gotoAppLogin();
return;
}
let dt = {
userId: this.user.id,
courseId: this.courseid
};
DelCollect(dt).then(res => {
if (res.success) {

this.collect = false;
}
});
},

goBuy() {
if (this.isavaliable != 0) {
this.$vux.toast.text("该课程已下架");
return;
}
if (!this.user || (this.user && !this.user.id)) {
this.gotoAppLogin();
} else {
let data_v = {
courseid: this.courseid,
shareuserid: this.shareuserid,
ordertype: this.ordertype
};
if (this.$route.query.member == 99) {
data_v.member = 99;
}
this.$router.push({
path: "/payorder",
query: data_v
});
}
},

toSharePoster() {
if (!this.user || (this.user && !this.user.id)) {
this.gotoAppLogin();
return;
}
this.$router.push({
path: "/postershare",
query: {
courseid: this.courseid,
ordertype: 2,
url:
window.location.href +
"&shareuserid=" +
this.user.id +
"&ordertype=2"
}
});
},
goStudy() {

if (!this.user || (this.user && !this.user.id)) {
this.gotoAppLogin();
return;
}
let dt = {
collegeId: this.college.id,
userId: this.user.id,
courseId: this.courseid,
reqchanle: "MOBILE"
};
getBuyfree(dt).then(res => {
console.log(res.message);
});
if (this.isBuy || this.currentPrice === 0) {
if (this.livePlayStau == 2 && this.sellType == "LIVE") {
this.$router.push(`/watch/${this.courseid}`);
return;
}
console.log("this.sellType");
console.log(this.sellType);

if (this.sellType == "PACKAGE") {
this.$router.push("/packagelist?courseid=" + this.courseid);
return;
}

this.$router.push({
path: "/LearnDetail",
query: {
courseid: this.courseid
}
});
return;
}else{
if(this.$route.query.member = 99 && this.$route.query.from == "vipmember"){
if (this.sellType == "PACKAGE") {

this.$router.push(`/packagelist?courseid=${this.courseid}&member=99&from=vipmember`);
return;
}
}
}

this.$router.push({
path: "/LearnDetail",
query: {
courseid: this.courseid
}
});
},

getFreeVideo() {
getCourseChapter({ courseid: this.courseid }).then(res => {
let dt = res.entity.courseKpoints;
for (const it of dt) {
let a = it.childKpoints;
a = a.find(item => {
return item.isAudition === 1;
});
if (a) this.freeUrl = a.videourl;
}
if(res.success){
this.getCourseChapterData = res.entity
}
});
},
goBack() {
if (
(this.$route.query.member = 99 && this.$route.query.from == "vipmember")
) {
this.$router.go(-1);
return;
}
if (this.$route.query.userid && this.$route.query.from == "zhxy") {
history.go(-1);
return;
}
if (
this.$route.query.userid ||
window.navigator.userAgent.indexOf("appxhjyjt_") != -1
) {




let _this = this;
try {
if (/android/i.test(window.navigator.userAgent)) {
AppUtil.redirect("historyback");
} else if (/iphone/i.test(window.navigator.userAgent)) {

window.webkit.messageHandlers.redirect.postMessage({
type: "historyback"
});
}
} catch (e) {
_this.$router.go(-1);
}
return;
}
if (window.history.length <= 1) {
this.$router.push({ path: "/HomePage" });
return;
}
if (this.$route.query.page) {
this.$router.go(-2);
} else {
this.$router.go(-1);
}
},
_getLiveInfo(id) {
getLiveBackInfo(id).then(res => {

if (res.success) {
this.$vux.alert.show({
title: "温馨提示",
content:
"直播暂未开始，敬请期待 <br> 直播开始时间：<br>" +
res.entity.course.addtime
});
}
});
},
beginTimer() {
if (this.ticker) {
return;
}
this.ticker = setInterval(() => {
let tNow = new Date();
for (let i = 0; i < this.swiperList.length; i++) {
const item = this.swiperList[i];
if (!isNaN(item.spellgroupendtime)) {
item.spellgroupendtime = item.spellgroupendtime - 1000;
} else {
var td = new Date(item.spellgroupendtime);
let leftTime = td.getTime() - tNow.getTime();

if (leftTime > 0) {
item.spellgroupendtime = leftTime;
}
}
}
}, 1000);
},
timeCount(time) {
let timeArr = {
h: "",
m: "",
s: ""
};


/* 将接收到的时间数加上现在的时间，设置定时器，减去现在的时间 */

let d, h, m, s;
if (time > 0) {
d = Math.floor(time / 1000 / 60 / 60 / 24);
h = Math.floor((time / 1000 / 60 / 60) % 24);
m = Math.floor((time / 1000 / 60) % 60);
s = Math.floor((time / 1000) % 60);
if (d > 0) {
h = d * 24 + h;
}
if (h < 10) {
h = `0${h}`;
}
if (m < 10) {
m = `0${m}`;
}
if (s < 10) {
s = `0${s}`;
}
timeArr.h = h;
timeArr.m = m;
timeArr.s = s;
} else {
for (const key in timeArr) {
timeArr[key] = "00";
}
}
return `${timeArr.h}:${timeArr.m}:${timeArr.s}`;
},
goChooseExam() {
this.$router.push({
path: "/chooseregion",
query: {
courseId: this.courseid,
mobileType: "h5"
}
});
},
gotoAppLogin() {
if (window.navigator.userAgent.indexOf("appxhjyjt_") != -1) {

this.$vux.confirm.show({
title: "用户信息过期",
content: "请在APP中重新登录",
showCancelButton: false,
onConfirm() {
console.log("fafa78");
try {
if (/android/i.test(window.navigator.userAgent)) {
AppUtil.redirect("applogin");
} else if (/iphone/i.test(window.navigator.userAgent)) {
window.webkit.messageHandlers.redirect.postMessage({
type: "applogin"
});
}
} catch (e) {
console.log(e);
}
}
});
} else {
this.$router.push("/login");
}
}
},
computed: {
pintuanListAll() {
return this.swiperList;
},
...mapGetters(["user", "college"])
},
beforeCreate() {
let script = document.createElement("script");
script.type = "text/javascript";
script.id = "scriptPlayerBack";

script.src = "https://player.polyv.net/script/polyvplayer.min.js";
document.getElementsByTagName("head")[0].appendChild(script);
},
beforeDestroy() {
this.ticker = null;
},
mounted() {

if (this.user) {
this.username = this.user.nickname;
this.userhead = this.user.avatar;
}
let userid = this.$route.query.userid ? this.$route.query.userid : "";
let collegeid = this.$route.query.collegeid
? this.$route.query.collegeid
: "";
if (userid !== "") {
let userJson = {
id: parseInt(userid),
avatar: "",
nickname: "",
mobile: "",
realname: "",
userInfo: "",
gender: "",
lastLoginTime: "",
createdate: "",
customerkey: this.$route.query.customerkey
? this.$route.query.customerkey
: "",
idNumber: ""
};
console.log(userJson, "-=");
this.saveUserAction(userJson);
let json = {
college_id: collegeid,
id: collegeid
};
this.saveCollegeAction(json);
}
if (this.$route.query.sharewechat) {
this.sharewechat = true;
}
this.courseid = this.$route.query.courseid;

this.shareuserid = this.$route.query.shareuserid
? this.$route.query.shareuserid
: "";
this.ordertype = this.$route.query.ordertype
? this.$route.query.ordertype
: "";

this.loading = true;
let dt = {
collegeId: this.college.id,
courseid: this.courseid,
userid: this.user ? this.user.id : ""
};
if (this.$route.query.member == 99) {
dt.memberCourseFlag = 1;
}
getCoursesDetail(dt).then(res => {

this.loading = false;
this.isavaliable = res.entity.isavaliable ? res.entity.isavaliable : 0;
this.currentPrice = res.entity.currentprice;
this.BeforePrice = res.entity.sourceprice;
this.detailName = res.entity.name;
this.detailTitle = res.entity.title;
this.detailContext = res.entity.app_context;
this.collect = res.entity.isfav;
this.sellType = res.entity.sellType;
this.videoImg = res.entity.infoLogo;
this.isBuy = res.entity.isBuy;
this.kefu = res.entity.outer_url ? res.entity.outer_url : "";
this.spellgroupprice = res.entity.spellgroupprice;

this.checkBeforeBuy = res.entity.checkBeforeBuy;

this.canBuyFlag = res.entity.canBuyFlag;
console.log("fafa::");
console.log(res.entity.userMemberCourse);
this.userMemberCourse = res.entity.userMemberCourse;
if (res.entity.spellgroup) {
this.spellStatus = res.entity.spellgroup;
}
if (res.entity.spellgroupstatus) {
this.spellgroupstatus = res.entity.spellgroupstatus;
}

let courseInfo = {
detailName: res.entity.name,
detailContext: res.entity.app_context,
infoLogo: res.entity.infoLogo
};
sessionStorage.setItem("courseInfo", JSON.stringify(courseInfo));

this.earnShow = res.entity.distribution;
this.earnMoney = res.entity.distributionprice;
this.livePlayStau = res.entity.livePlayStau;
this.share = {
title: res.entity.name,
desc: res.entity.title
};

if (this.sellType == "LIVE") {
this.tabList = this.tabList.filter(item => item.id != 2);
}

if (this.sellType === "REALPRODUCT") {
this.tabList = [
{
id: 1,
name: "介绍",
choosed: true
}
];
}

if (res.entity.livePlayStau == 1) {

}

if (this.fromPage == "login") {
if (this.isBuy === 1 || this.currentPrice === 0) {
this.goStudy(); 
} else if (
!this.isBuy &&
this.currentPrice !== 0 &&
this.spellStatus == 2 &&
this.spellgroupstatus != 2 &&
this.isavaliable == 0
) {
this.goBuy(); 
}
return;
}
});
this.pintuanList();
this.getFreeVideo();

},
beforeRouteEnter(to, from, next) {
if (to.name) {


}
next(vm => {

vm.fromPage = from.name;
});
},







watch: {
showVideo(newVal, oldVal) {
document.querySelector("#video1").innerHTML = "";
if (newVal) {
this.player = polyvObject("#video1").videoPlayer({
width: "100%",
height: "100%",
vid: this.freeUrl,
loading_bg_img: `${staticHost}${this.videoImg}`
});
}
}
}
};



// WEBPACK FOOTER //
// ./src/page/lessionDetail.vue